import { render, staticRenderFns } from "./MasqueradingBanner.vue?vue&type=template&id=d6bec18a&scoped=true&"
import script from "./MasqueradingBanner.vue?vue&type=script&lang=js&"
export * from "./MasqueradingBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6bec18a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/staging.portal.letsreimagine.org/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d6bec18a')) {
      api.createRecord('d6bec18a', component.options)
    } else {
      api.reload('d6bec18a', component.options)
    }
    module.hot.accept("./MasqueradingBanner.vue?vue&type=template&id=d6bec18a&scoped=true&", function () {
      api.rerender('d6bec18a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/user/components/MasqueradingBanner.vue"
export default component.exports